// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__wmAwu","winter":"AboutUs_winter__KOPum","summer":"AboutUs_summer__WJUhV","img":"AboutUs_img__MvZcn"};